<template>
    <div>
      <div id="container">
        <!-- Navigation -->
        <main>
            <CommonNavbar />
        </main>
  
        <!-- Divider -->
        <hr class="mt-0 mb-0" />
        <!-- End Divider -->
  
        <!-- BANNER -->
        <div style="width: 100%; overflow: hidden; margin-top: -3px;" id="mainbanner">
          <div style="width: 100%; margin-right: auto;">
            <img class="banner-img" alt="Responsive image" :src="require('@/assets/aogs2025/img/myimages/微信图片_20250704112540.png')" style="width: 100%;">
          </div>
        </div>
        <div style="width: 100%; overflow: hidden;" id="mob">
          <div style="width: 100%; margin-right: auto;">
            <img class="banner-img" alt="Responsive image" :src="require('@/assets/aogs2025/img/AOGS2025 WEB DESIGN-03.png')" style="width: 100%;">
          </div>
        </div>
  
        <br />
  
        <div class="container container-layout" id="main-container">
          <h2 class="MMI-titleR">
            <b>Registration</b> 
            <font style="font-size: 22px;">Opens 01 Apr 2025</font>
            <a href="#CF" class="btn btn-sm btn-outline-primary sub-hyp-link">Categories & Fees</a>
            <a href="#RP" class="btn btn-sm btn-outline-primary sub-hyp-link">Registration & Payment</a>
            <a href="#PCC" class="btn btn-sm btn-outline-primary sub-hyp-link">ISACI Policies & Code of Conduct</a>
            <a href="public.asp_page=author-presenter_profile.asp.html" class="btn btn-sm btn-outline-primary sub-hyp-link">Author/Presenter Profile</a>
          </h2>
          <hr align="left" class="MMI_horizl" />
  
          <h4 style="color: #000E70; padding-top: 15px; scroll-margin-top: 90px;" id="CF"><b>Categories & Fees</b></h4>
          <table class="MMI-text">
            <tbody>
              <tr>
                <td style="vertical-align: top;">Goods & <br />
                  Services <br />
                  Tax (GST)</td>
                <td>
                  <ul>
                    <li>Fee amounts are not inclusive of Goods and Services Tax (GST)</li>
                    <li>The current GST rate is 9%</li>
                    <li>GST is zero-rated for payees whose businesses are registered outside Singapore (i.e. you will not be required to pay GST)</li>
                  </ul>
                </td>
              </tr>
              <tr>
                <td style="vertical-align: top;">Deadlines</td>
                <td>
                  <ul>
                    <li>All deadlines are based on Singapore Time (GMT+8). The cut-off time will be 11:55pm on the specified deadline date.</li>
                    <li>All authors and presenters have up till 27 May 2025 to register and pay fees. The final registration date, however, is 20 May, 2025 for participants who are receiving financial assistance, such as - student volunteers, free registrations, or reduced registration fees.</li>
                    <li>Early bird fee expires on 27 May 2025. If paid after 27 May 2025, fees will increase</li>
                    <li>On 31 May 2025, unregistered presentations will be removed from the program</li>
                  </ul>
                </td>
              </tr>
            </tbody>
          </table>
  
          <div>
            <table class="MMI-text table-responsive table w-100 d-block">
              <colgroup>
                <col width="56%" />
                <col width="20%" />
                <col width="12%" />
                <col width="12%" />
              </colgroup>
              <tbody>
                <tr>
                  <td rowspan="2" style="background-color: #CFE2FF; color: #055160;"><b>CONFERENCE FEE – REGULAR</b></td>
                  <td style="background-color: #CFE2FF; color: #055160; text-align: center;"><b>Author, Presenter <br />
                    & Early Bird Discount</b></td>
                  <td style="background-color: #CFE2FF; color: #055160; text-align: center;"><b>Late</b></td>
                  <td style="background-color: #CFE2FF; color: #055160; text-align: center;"><b>Onsite</b></td>
                </tr>
                <tr>
                  <td style="background-color: #CFE2FF; color: #055160; text-align: center;"><b>01 Apr – 27 May</b></td>
                  <td style="background-color: #CFE2FF; color: #055160; text-align: center;"><b>28 May – 26 Jul</b></td>
                  <td style="background-color: #CFE2FF; color: #055160; text-align: center;"><b>After 26 Jul</b></td>
                </tr>
                <tr>
                  <td><sup>1</sup> ISACI Current Member</td>
                  <td style="text-align: center;">SGD750</td>
                  <td style="text-align: center;">SGD950</td>
                  <td style="text-align: center;">SGD1050</td>
                </tr>
                <tr>
                  <td><sup>1</sup> ISACI Partner Society Current Member AGU, AMOS, EGU, JPGU, KGU, TCGU</td>
                  <td style="text-align: center;">SGD750</td>
                  <td style="text-align: center;">SGD950</td>
                  <td style="text-align: center;">SGD1050</td>
                </tr>
                <tr>
                  <td>New Member</td>
                  <td style="text-align: center;">SGD950</td>
                  <td style="text-align: center;">SGD1150</td>
                  <td style="text-align: center;">SGD1350</td>
                </tr>
                <tr>
                  <td><sup>2</sup> Retiree Over 60 years of age & are employed not more than 10% full time in a professional capacity</td>
                  <td style="text-align: center;">SGD380</td>
                  <td style="text-align: center;">SGD480</td>
                  <td style="text-align: center;">SGD530</td>
                </tr>
                <tr>
                  <td style="background-color: #CFE2FF; color: #055160;"><b>CONFERENCE FEE – ISACI FUNDED</b><br />
                    <font style="color: #C00000; font-size: 12px;">Those who meet the requirements will be allowed to register (and pay if applicable)</font>
                  </td>
                  <td colspan="3" style="background-color: #CFE2FF; color: #055160; text-align: center;"><b>Final Registration Date is 20 May 2025</b></td>
                </tr>
                <tr>
                  <td>Reduced – Regular</td>
                  <td colspan="3" style="text-align: center;">SGD460</td>
                </tr>
                <tr>
                  <td><sup>3</sup> Reduced – Student</td>
                  <td colspan="3" style="text-align: center;">SGD230</td>
                </tr>
                <tr>
                  <td><sup>3</sup> Student Volunteer</td>
                  <td colspan="3" style="text-align: center;">Fee Waived</td>
                </tr>
                <tr>
                  <td>Complimentary Registration</td>
                  <td colspan="3" style="text-align: center;">Fee Waived</td>
                </tr>
                <tr>
                  <td rowspan="2" style="background-color: #CFE2FF; color: #055160;"><b>STUDENT FEE</b></td>
                  <td style="background-color: #CFE2FF; color: #055160; text-align: center;"><b>Author Presenter & <br />
                    Early Bird</b></td>
                  <td style="background-color: #CFE2FF; color: #055160; text-align: center;"><b>Late</b></td>
                  <td style="background-color: #CFE2FF; color: #055160; text-align: center;"><b>Onsite</b></td>
                </tr>
                <tr>
                  <td style="background-color: #CFE2FF; color: #055160; text-align: center;"><b>01 Apr – 27 May</b></td>
                  <td style="background-color: #CFE2FF; color: #055160; text-align: center;"><b>28 May – 26 Jul</b></td>
                  <td style="background-color: #CFE2FF; color: #055160; text-align: center;"><b>After 26 Jul</b></td>
                </tr>
                <tr>
                  <td><sup>1, 3</sup> PhD Candidate – ISACI Current Member</td>
                  <td style="text-align: center;">SGD380</td>
                  <td style="text-align: center;">SGD480</td>
                  <td style="text-align: center;">SGD530</td>
                </tr>
                <tr>
                  <td><sup>1, 3</sup> PhD Candidate - Partner Society Current Member AGU, AMOS, EGU, JPGU, KGU, TCGU</td>
                  <td style="text-align: center;">SGD380</td>
                  <td style="text-align: center;">SGD480</td>
                  <td style="text-align: center;">SGD530</td>
                </tr>
                <tr>
                  <td><sup>3</sup> PhD Candidate - New Member</td>
                  <td style="text-align: center;">SGD480</td>
                  <td style="text-align: center;">SGD590</td>
                  <td style="text-align: center;">SGD680</td>
                </tr>
                <tr>
                  <td><sup>3</sup> Student - Master or Undergraduate</td>
                  <td style="text-align: center;">SGD190</td>
                  <td style="text-align: center;">SGD240</td>
                  <td style="text-align: center;">SGD270</td>
                </tr>
                <tr>
                  <td><sup>3</sup> Student - High School or Younger</td>
                  <td style="text-align: center;">SGD45</td>
                  <td style="text-align: center;">SGD60</td>
                  <td style="text-align: center;">SGD70</td>
                </tr>
                <tr>
                  <td style="background-color: #CFE2FF; color: #055160;"><b>Each Conference Registration/Paid Fee covers Two Presentations only<br />
                    Additional Fee is Payable – For Presenting Each Abstract in Excess of Two</b>
                  </td>
                  <td colspan="3" style="background-color: #CFE2FF; color: #055160; text-align: center;"><b>PER ADDITIONAL ABSTRACT FEE</b></td>
                </tr>
                <tr>
                  <td><sup>1</sup> ISACI Current Member</td>
                  <td colspan="3" style="text-align: center;">SGD230</td>
                </tr>
                <tr>
                  <td>Everyone Else – Including Current Members of ISACI Partner Societies</td>
                  <td colspan="3" style="text-align: center;">SGD460</td>
                </tr>
                <tr>
                  <td style="background-color: #CFE2FF; color: #055160;"><b>INVITE-ONLY CONVENER'S DINNER ON 01 AUG 2025 <a href="public.asp_page=program.asp.html#convenersDinner">Info here</a></b><br />
                    <font style="font-size: 12px;">
                      Reservation must be secured with SGD 100 payment in advance. Cash refund given to attendees on the spot.<br />
                      No shows will forfeit their deposit. <font style="color: #C00000;">Those who meet the requirements will be allowed to register (and pay if applicable)</font>
                    </font>
                  </td>
                  <td style="text-align: center;" colspan="3">
                    <font style="font-size: 12px;" class="text-danger">(Please note that Convener's Dinner tickets are sold out)</font>
                  </td>
                </tr>
                <tr>
                  <td colspan="4" style="background-color: #CFE2FF; color: #055160;">
                    <b>MENTOR-MENTEE PROGRAM – <a href="public.asp_page=program.asp.html#Mentor-Mentee_Program">Info Here</a></b>
                  </td>
                </tr>
                <tr>
                  <td>AI Enabled Mentor-Mentee Matching<br />
                    Free of Charge – Open to All Attendees</td>
                  <td colspan="3" style="text-align: center;">Sign up dates: 01 Apr to 27 May 2025</td>
                </tr>
                <tr>
                  <td colspan="4">
                    <b>Note Please:</b><br />
                    <font style="font-size: 12px;">
                      <sup>1</sup> Anyone registering under the current member category must have a valid membership ID whether ISACI or partner society.<br />
                      <sup>2</sup> Anyone registering under the retiree category must have a valid birthdate and proof of retirement such as a retirement letter or employment cessation notice.<br />
                      <sup>3</sup> Anyone registering under the student fee category must have a valid birthdate and proof of student status, such as a student card or student status letter.
                    </font>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
  
          <h4 style="color: #000E70; padding-top: 15px; scroll-margin-top: 90px;" id="RP">
            <b>Registration and Payment <font style="font-size: 15px; color: black;">(Opens 01 Apr 2025)</font></b>
          </h4>
          <div>
            <table class="MMI-text">
              <tbody>
                <tr>
                  <td style="vertical-align: top;"><b>1.</b></td>
                  <td style="padding-left: 25px;"><b>How to Register</b>
                    <table class="MMI-text">
                      <tbody>
                        <tr>
                          <td style="vertical-align: top;"><b>1.1.</b></td>
                          <td style="padding-left: 25px;"><b>Current Users – Individuals with an existing account on <a href="https://meetmatt-svr.net/Account/Login" target="_blank">MARS</a></b>
                            <ol type="a">
                              <li>Log-in with your email and password <a href="https://meetmatt-svr.net/Account/Login" target="_blank">here</a>.</li>
                              <li>Click on "Meeting Registration" on the left menu and follow the online instructions to complete your registration and fee payment.</li>
                            </ol>
                          </td>
                        </tr>
                        <tr>
                          <td style="vertical-align: top;"><b>1.2.</b></td>
                          <td style="padding-left: 25px;"><b>New Users</b>
                            <ol type="a">
                              <li>Create new user account <a href="https://meetmatt-svr.net/Account/Login" target="_blank">here</a>.</li>
                              <li>Log-in with your email and password.</li>
                              <li>Click on "Meeting Registration" on the left menu and follow the online instructions to complete your registration and fee payment.</li>
                            </ol>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </td>
                </tr>
                <tr>
                  <td style="vertical-align: top;"><b>2.</b></td>
                  <td style="padding-left: 25px;"><b>Payment Methods</b>
                    <table class="MMI-text">
                      <tbody>
                        <tr>
                          <td style="vertical-align: top;"><b>2.1.</b></td>
                          <td style="padding-left: 25px;"><b>Card Payment</b>
                            <ol type="a">
                              <li>Accepted Cards: MasterCard, Visa, UnionPay, Diners Club, JCB, Amex</li>
                              <li>For securing Card-Not-Present (CNP) transactions against fraud, Visa and Master Cards are required to be 3D Secure enabled or payment requests will be declined. If your credit card is not 3D Secure enabled, please get in touch with your card issuer/bank to request for it to be enabled.</li>
                            </ol>
                          </td>
                        </tr>
                        <tr>
                          <td style="vertical-align: top;"><b>2.2.</b></td>
                          <td style="padding-left: 25px;"><b>Digital Wallet & Mobile Payment</b>
                            <ol type="a">
                              <li>Discover, Alipay, WeChat Pay</li>
                              <li>PayNow, Shopee Pay & GrabPay supports Singapore Only Payments</li>
                            </ol>
                          </td>
                        </tr>
                        <tr>
                          <td style="vertical-align: top;"><b>2.3.</b></td>
                          <td style="padding-left: 25px;"><b>All Other Payment Methods</b>
                            <ol type="a">
                              <li><b>Singapore Dollar (SGD)</b> is the official currency for the conference.</li>
                              <li>Cheque, Bank Transfer</li>
                              <li>Deadline for Bank Transfer is 27 May 2025.</li>
                              <li>Please note that SGD 90.00 Platform Fee applies.</li>
                              <li>All bank charges are borne by remitter (ordering customer).</li>
                              <li>Bank Document must include conference name (AOGS2025) and author/presenter name.</li>
                              <li>Upon completion of the transfer, please email Secretariat your bank document for tracking purposes to <a href="mailto:info@asiaoceania.org" target="_blank">info@asiaoceania.org</a></li>
                            </ol>
                            <div style="padding-left: 10px;">
                              <table>
                                <tbody>
                                  <tr>
                                    <td colspan="2"><b>Bank Details</b></td>
                                  </tr>
                                  <tr>
                                    <td>UEN (PayNow)</td>
                                    <td>: 200210443E</td>
                                  </tr>
                                  <tr>
                                    <td>Account Name</td>
                                    <td>: Meeting Matters International Pte Ltd</td>
                                  </tr>
                                  <tr>
                                    <td>Account Number</td>
                                    <td>: 003-902606-4</td>
                                  </tr>
                                  <tr>
                                    <td>Bank Name</td>
                                    <td>: DBS Bank Ltd</td>
                                  </tr>
                                  <tr>
                                    <td>Bank Address</td>
                                    <td>: 12 Marina Boulevard, Level 3, DBS Asia Central @ MBFC Tower 3, Singapore 018982</td>
                                  </tr>
                                  <tr>
                                    <td>Swift Code</td>
                                    <td>: DBSSSGSG</td>
                                  </tr>
                                  <tr>
                                    <td>Bank Code</td>
                                    <td>: 7171</td>
                                  </tr>
                                  <tr>
                                    <td>Branch Code</td>
                                    <td>: 003</td>
                                  </tr>
                                </tbody>
                              </table>
                              <p></p>
                            </div>
                          </td>
                        </tr>
                        <tr>
                          <td style="vertical-align: top;"><b>2.4.</b></td>
                          <td style="padding-left: 25px;"><b>Payment Disputes/Queries</b>
                            All payment related disputes/queries and chargebacks will be handled by Meeting Matters International Pte Ltd.<br />
                            Please contact: ISACI Secretariat c/o Meeting Matters International Pte Ltd<br />
                            Address: #06-23 One Commonwealth, 1 Commonwealth Lane, Singapore 149544<br />
                            Tel: +65 6472 3108 | Fax: +65 6472 3208 | Email: <a href="mailto:info@asiaoceania.org" target="_blank">info@asiaoceania.org</a>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
  
          <br />
  
          <h4 style="color: #000E70; padding-top: 15px; scroll-margin-top: 90px;" id="PCC"><b>Policies & Code of Conduct</b></h4>
          <div>
            <table class="MMI-text">
              <tbody>
                <tr>
                  <td style="vertical-align: top;"><b>1.</b></td>
                  <td style="padding-left: 25px;"><b>Policies</b>
                    <table class="MMI-text">
                      <tbody>
                        <tr>
                          <td style="vertical-align: top;"><b>1.1.</b></td>
                          <td style="padding-left: 25px;"><b>Presenter / Keynote / Poster Presentation Terms & Conditions</b>
                            <ol type="a">
                              <li>Presenters accepted in the conference program are required to register and pay their own attendance.</li>
                              <li>Presenter passes issued for use at the conference are valid for named attendees only and, subject to Clause 1.1c below, cannot be transferred. You may be asked for photographic ID during the conference. If you are unable to provide identification which matches your attendee pass you may be asked to leave the conference.</li>
                              <li>If you are unable to attend the conference, we welcome a substitute presenter attending in your place at no extra cost provided that we have at least 14 days prior notice of the name of your proposed substitute and have received payment in full.</li>
                              <li>Conference registration fees are not refundable for cancellation notice received on or after 27 May 2025. There will be an admin fee of SGD90 for any refunds made.</li>
                              <li>Your participation in AOGS2025 constitutes your consent to be photographed, filmed, and/or otherwise recorded and to the release, publication, exhibition, or reproduction of any recorded media of your appearance, voice, and name for any purpose whatsoever in perpetuity in connection with the AOGS2025 organizers and their initiatives, including, by way of example only, use on websites, in social media, news and advertising.</li>
                            </ol>
                          </td>
                        </tr>
                        <tr>
                          <td style="vertical-align: top;"><b>1.2.</b></td>
                          <td style="padding-left: 25px;"><b>Conference Registration Fee Includes:</b>
                            <ol type="a">
                              <li>ISACI Membership, valid for three annual meeting years</li>
                              <li>Admission to All Conference Sessions</li>
                              <li>Registration Fee Payment Receipts and Invoices</li>
                              <li>Official Attendance Certificate</li>
                            </ol>
                          </td>
                        </tr>
                        <tr>
                          <td style="vertical-align: top;"><b>1.3.</b></td>
                          <td style="padding-left: 25px;"><b>Indemnity</b>
                            <ol type="a">
                              <li>While the organizer will make every effort to screen operators and observe best safety practices, the individual must accept personal responsibility for insurance against travel risk and injury.</li>
                              <li>Participants on field trips/tours agree to indemnify ISACI, the conference secretariat and the conference organizers against any claims as arising from injury or loss sustained during the outings.</li>
                              <li>Please note that participants are responsible for their own insurance.</li>
                            </ol>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </td>
                </tr>
                <tr>
                  <td style="vertical-align: top;"><b>2.</b></td>
                  <td style="padding-left: 25px;"><b>ISACI Code of Conduct (Year Instituted: 2022)</b><br />
                    <a href="public.asp_page=support_and_resources.asp.html#ACC">Click here for details.</a>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
  
          <h4 style="color: #000E70; padding-top: 15px;"><b></b></h4>
          <p class="MMI-text"></p>
        </div>
  
        <br />
        <br />
        <br />
      </div>
  
      <!-- Footer -->
      <CommonFooter />
    </div>
</template>

<script>
import CommonFooter from '@/components/CommonFooter.vue'
import CommonNavbar from '@/components/CommonNavbar.vue'

export default {
  name: 'MettingRegistration',
  components: {
    CommonNavbar,
    CommonFooter
  }
}
</script>

<style scoped>
/* 导入原始样式 */
.MMI-titleR {
  font-size: 28px;
  margin-bottom: 10px;
  line-height: 1.2;
  font-weight: 600;
  color: #000E70;
  margin-bottom: 0px;
  margin-top: 0px;
}

.MMI-text {
  font-size: 14.5px;
  margin-bottom: 10px;
  line-height: 1.2;
  font-weight: 500;
  color: darkslategrey;
  margin-bottom: 0px;
  margin-top: 0px;
}

.MMI_horizl {
  border: none;
  height: 3px;
  background: linear-gradient(90deg, rgba(29,151,208,1) 25%, rgba(0,14,112,1) 70%);
  margin: 20px 0;
}

.sub-hyp-link {
  margin-bottom: 5px;
  font-weight: 550;
  font-size: 12.5px;
}

.table-responsive td, th {
  border: 1px solid black;
  padding: 5px;
  text-align: left;
  vertical-align: middle;
  text-align: left;
  font-size: 13.5px;
}

.hotel-title {
  line-height: 1.1;
}
</style>
